<template>
    <div v-if="showCookieBanner" class="sticky z-50">
        <div class="w-full p-5 lg:px-24 shadow-lg bg-grey-700 text-white">
            <div class="md:flex items-center -mx-3">
                <div class="md:flex-1 px-3 mb-5 md:mb-0">
                    <p class="text-center md:text-left text-white text-xs leading-tight md:pr-12">
                        We and selected partners and related companies, use cookies and similar technologies as
                        specified in
                        our Cookies Policy. You agree to consent to the use of these technologies by clicking Accept, or
                        by
                        continuing to browse this website. You can learn more about how we use cookies and set cookie
                        preferences in Settings.
                    </p>
                </div>

                <div class="px-3 text-center">
                    <button
                        class="font-condensed transition-all bg-grey-800 hover:bg-grey-900 text-white font-bold py-2 px-4 rounded-md mr-4"
                        @click.prevent="onOpenSettingsClick">Cookie settings
                    </button>

                    <button
                        class="font-condensed transition-all bg-glm-red hover:bg-red-800 text-white font-bold py-2 px-4 rounded-md"
                        @click.prevent="onAcceptAll">Accept All
                    </button>
                </div>
            </div>
        </div>

        <div v-if="showCookieSettings"
             class="shadow-lg bg-white overflow-auto rounded-md absolute mt-4 w-11/12 md:w-1/3"
             style="max-height: 40rem; left: 50%; transform: translateX(-50%)">
            <div class="flex flex-col w-full h-auto">
                <div class="flex w-full h-auto items-center px-5 py-3">
                    <div class="w-10/12 h-auto text-lg font-bold">
                        Cookie settings
                    </div>

                    <div class="flex w-2/12 h-auto justify-end">
                        <button @click.prevent="onCloseCookieSettings"
                                class="cursor-pointer focus:outline-none text-gray-400 hover:text-gray-800">
                            <font-awesome-icon
                                :icon="['fad', 'times-circle']"
                                size="lg"
                                class="fa-fw"
                            ></font-awesome-icon>
                        </button>
                    </div>
                </div>

                <div v-for="cookie in cookies" :key="cookie.cookieName"
                     class="flex w-full items-center bg-gray-100 border-b border-gray-200 px-5 py-3 text-sm"
                     @click="toggleCookie(cookie)">
                    <div class="flex-1">
                        <p class="font-bold">{{ cookie.displayName }}</p>

                        <p class="text-sm text-grey-700">
                            {{ cookie.description }}
                        </p>
                    </div>

                    <div v-if="cookie.optional" class="w-10">
                        <input type="checkbox" :checked="getCookieStatus(cookie) ? 'checked' : null"
                               class="cookie__consent__switch-input">

                        <label class="cookie__consent__switch-label"></label>
                    </div>

                    <div v-else class="w-10 text-right">
                        <font-awesome-icon
                            :icon="['fad', 'check-circle']"
                            size="lg"
                            class="fa-fw text-green-500"
                        ></font-awesome-icon>
                    </div>
                </div>

                <div class="flex w-full h-auto items-center px-5 py-3">
                    <div class="flex w-full h-auto justify-end">
                        <button @click.prevent="onCloseCookieSettings"
                                class="font-condensed transition-all bg-glm-red hover:bg-red-800 text-white font-bold py-2 px-4 rounded-md inline-block">

                            Save Cookie settings

                            <font-awesome-icon
                                :icon="['fad', 'save']"
                                class="fa-fw ml-3"
                            ></font-awesome-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import collect from 'collect.js';
import * as Cookie from 'tiny-cookie';

export default {
    props: {
        cookies: {
            type: Array,
        },

        dialogCookieName: {
            type: String,

            default: 'cookie_consent',
        },
    },

    data()
    {
        return {
            showCookieBanner: true,
            showCookieSettings: false,

            cookieValue: 1,
            renderKey: 0,
        };
    },

    mounted()
    {
        // Create all none optional cookies.
        collect(this.cookies).where('optional', false).each((cookie) => {
            this.consentWithCookie(cookie);
        });

        if (this.cookieExists(this.dialogCookieName)) {
            this.showCookieBanner = false;
            this.showCookieSettings = false;
        }

        // Set dialog to already shown.
        if (!this.cookieExists(this.dialogCookieName)) {
            // this.setCookie(this.dialogCookieName, 1);
        }
    },

    methods: {
        forceRenderer()
        {
            this.renderKey++;
            this.$forceUpdate();
        },

        toggleCookie(cookie)
        {
            if (cookie.optional === true) {
                let cookieExists = this.cookieExists(cookie.cookieName);

                if (cookieExists === false) {
                    this.consentWithCookie(cookie);
                }

                if (cookieExists === true) {
                    this.retractCookieConsent(cookie);
                }
            }
        },

        getCookieStatus(cookie)
        {
            if (this.cookieExists(cookie.cookieName)) {
                return true;
            }

            return cookie.initialStatus;
        },

        consentWithCookie(cookie)
        {
            if (!this.cookieExists(cookie.cookieName)) {
                this.setCookie(cookie.cookieName, this.cookieValue);
            }

            this.forceRenderer();
        },

        retractCookieConsent(cookie)
        {
            if (this.cookieExists(cookie.cookieName) && cookie.optional === true) {
                this.removeCookie(cookie.cookieName);
            }

            this.forceRenderer();
        },

        cookieExists(cookieName)
        {
            return Cookie.get(cookieName) !== null;
        },

        setCookie(name, value, expiresInDays)
        {
            Cookie.setCookie(name, value, {expires: '1Y'});
        },

        removeCookie(name)
        {
            Cookie.removeCookie(name);
        },

        hideCookieDialog()
        {
            this.showCookieSettings = false;
            this.showCookieBanner = false;

            this.setCookie(this.dialogCookieName, 1);

            location.reload();
        },

        onOpenSettingsClick()
        {
            this.showCookieSettings = true;
        },

        onCloseCookieSettings()
        {
            this.hideCookieDialog();
        },

        onAcceptAll()
        {
            collect(this.cookies).each((cookie) => this.consentWithCookie(cookie));

            this.hideCookieDialog();
        },
    },
};
</script>

<style scoped lang="scss">
/**
  Switch toggles
 */
.cookie__consent__switches {
    width: 100%;
    display: inline-flex;
    align-items: center;
    height: 50px;
}

.cookie__consent__switches > div > p {
    font-weight: bold;
    width: 100px;
}

.cookie__consent__switch-input {
    display: none;
}

.cookie__consent__switch-label {
    position: relative;
    display: block;
    cursor: pointer;
    font-weight: 500;
    text-align: left;
    margin-top: 1px;
    margin-left: -10px;
}

.cookie__consent__switch-label:before,
.cookie__consent__switch-label:after {
    content: "";
    position: absolute;
    margin: 0;
    outline: 0;
    top: 50%;
    -ms-transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

.cookie__consent__switch-label:before {
    background: #F4F5F7;
    left: 1px;
    width: 57px;
    height: 32px;
    box-shadow: 2px 2px 11px 0px rgba(0, 0, 0, 0.03) inset;
    border-radius: 200px;
}

.cookie__consent__switch-label:after {
    background: white;
    left: 5px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -1px rgba(0, 0, 0, .06);
}

.cookie__consent__switch-label .cookie__consent__toggle--on {
    display: none;
}

.cookie__consent__switch-label .cookie__consent__toggle--off {
    display: inline-block;
}

.cookie__consent__switch-input:checked + .cookie__consent__switch-label:before {
    background: #36B37E;
}

.cookie__consent__switch-input:checked + .cookie__consent__switch-label:after {
    background: white;
    -ms-transform: translate(100%, -50%);
    -webkit-transform: translate(100%, -50%);
    transform: translate(100%, -50%);
}

.cookie__consent__switch-input:checked + .cookie__consent__switch-label .cookie__consent__toggle--on {
    display: inline-block;
}

.cookie__consent__switch-input:checked + .cookie__consent__switch-label .cookie__consent__toggle--off {
    display: none;
}
</style>
